import AppBarPropsColorOverrides from '@mui/material/AppBar'

declare module '@mui/material/AppBar' {
  interface AppBarPropsColorOverrides {
    light: true;
    slate: true;
  }
}
export const MuiAppBar = {}
